import { SET_VAL } from "../actions/types";

export default (val = "", action) => {
  if (action.type === SET_VAL) {
    return action.payload;
  }
  return val;
};
